import React from 'react';

import './index.css';

const SendInvite = (props) => {
  const onClick = (e) => {
    e.stopPropagation();
    props.onClick(props.row);
  }

  const time = props.row.invitedTime;
  let text;
  if (!time) {
    text = 'Send Invite';
  } else if (time === 'Invite sent') {
    text = 'Invite Sent';
  } else {
    text = 'Re-send Invite';
  }

  return (
    <span onClick={onClick} className={text === 'Invite Sent' ? 'plain-text' : 'dashed-text'}>
      { text }
    </span>
  );
}

export default SendInvite;